import { store } from '@store/index';

interface Data {
    isDirector: boolean;
    hasRootAccess: boolean;
    isDeveloper: boolean;
    isHelpdesk: boolean;
    isAssistant: boolean;
    isDoctor: boolean;
    isHeadOfClinic: boolean;
}

export function useAuthUserRole(): Data {
    const { authUser } = store;

    return {
        isDirector: authUser.isDirector,
        isDeveloper: authUser.isDeveloper,
        hasRootAccess: authUser.hasRootAccess,
        isAssistant: authUser.isAssistant,
        isDoctor: authUser.isDoctor,
        isHelpdesk: authUser.isHelpdesk,
        isHeadOfClinic: authUser.isHeadOfClinic,
    };
}
